export default __webpack_public_path__ + "static/media/support.6fa61f4d.svg";